const longHours = [
    {
        datetime: "2021-11-29T10:40:45.000Z",
        value: 1.8,
        baseline: 1,
    },
    {
        datetime: "2021-11-30T15:26:51.000Z",
        value: 0.5,
        baseline: 1,
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        value: 0.5,
        baseline: 0,
    },
    {
        datetime: "2021-12-02T15:26:51.000Z",
        value: 1.5,
        baseline: 1,
    },
    {
        datetime: "2021-12-03T15:26:51.000Z",
        value: 1,
        baseline: 2,
    },
    {
        datetime: "2021-12-04T15:26:51.000Z",
        value: 1.9,
        baseline: 1,
    },
    {
        datetime: "2021-12-05T15:26:51.000Z",
        value: 0.5,
        baseline: 0.5,
    },
];

const outOfHours = [
    {
        datetime: "2021-11-29T10:40:45.000Z",
        value: 23,
        baseline: 20,
    },
    {
        datetime: "2021-11-30T15:26:51.000Z",
        value: 13,
        baseline: 21,
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        value: 25,
        baseline: 17,
    },
    {
        datetime: "2021-12-02T15:26:51.000Z",
        value: 20,
        baseline: 18,
    },
    {
        datetime: "2021-12-03T15:26:51.000Z",
        value: 23,
        baseline: 9,
    },
    {
        datetime: "2021-12-04T15:26:51.000Z",
        value: 17,
        baseline: 20,
    },
    {
        datetime: "2021-12-05T15:26:51.000Z",
        value: 2,
        baseline: 15,
    },
];

const focusTime = [
    {
        datetime: "2022-06-17T00:00:00.000Z",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T00:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T01:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T02:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T03:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T04:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T05:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T06:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T07:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T08:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-17T09:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-17T10:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-17T11:00:00.000Z",
            },
            {
                messages: 240,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T12:00:00.000Z",
            },
            {
                messages: 180,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T13:00:00.000Z",
            },
            {
                messages: 120,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T14:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T15:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T16:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T17:00:00.000Z",
            },
            {
                messages: 1020,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T18:00:00.000Z",
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T19:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T20:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T21:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T22:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-17T23:00:00.000Z",
            },
        ],
    },
    {
        datetime: "2022-06-18T00:00:00.000Z",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T00:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T01:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T02:00:00.000Z",
            },
            {
                messages: 0,
                focus: 0,
                huddles: 0,
                meetings: 0,
                datetime: "2022-06-18T03:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T04:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T05:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T06:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T07:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T08:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 400,
                focus: 0,
                datetime: "2022-06-18T09:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T10:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T11:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T12:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T13:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T14:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T15:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T16:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T17:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T18:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T19:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T20:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T21:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T22:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-18T23:00:00.000Z",
            },
        ],
    },
    {
        datetime: "2022-06-19T00:00:00.000Z",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T00:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T01:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T02:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T03:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T04:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T05:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T06:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T07:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T08:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T09:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T10:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T11:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T12:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T13:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T14:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T15:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T16:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T17:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T18:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T19:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T20:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T21:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T22:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-19T23:00:00.000Z",
            },
        ],
    },
    {
        datetime: "2022-06-20T00:00:00.000Z",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T00:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T01:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T02:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T03:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T04:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T05:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T06:00:00.000Z",
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T07:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T08:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-20T09:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-20T10:00:00.000Z",
            },
            {
                messages: 180,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T11:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T12:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T13:00:00.000Z",
            },
            {
                messages: 300,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T14:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T15:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T16:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T17:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T18:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T19:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T20:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T21:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T22:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-20T23:00:00.000Z",
            },
        ],
    },
    {
        datetime: "2022-06-21T00:00:00.000Z",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T00:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T01:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T02:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T03:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T04:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T05:00:00.000Z",
            },
            {
                messages: 300,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T06:00:00.000Z",
            },
            {
                messages: 900,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T07:00:00.000Z",
            },
            {
                messages: 120,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T08:00:00.000Z",
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-21T09:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-21T10:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T11:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T12:00:00.000Z",
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T13:00:00.000Z",
            },
            {
                messages: 840,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T14:00:00.000Z",
            },
            {
                messages: 420,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T15:00:00.000Z",
            },
            {
                messages: 300,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T16:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T17:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T18:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T19:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T20:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T21:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T22:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-21T23:00:00.000Z",
            },
        ],
    },
    {
        datetime: "2022-06-22T00:00:00.000Z",
        perHour: [
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T00:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T01:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T02:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T03:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T04:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T05:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T06:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T07:00:00.000Z",
            },
            {
                messages: 420,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T08:00:00.000Z",
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-22T09:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 1,
                datetime: "2022-06-22T10:00:00.000Z",
            },
            {
                messages: 60,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T11:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T12:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T13:00:00.000Z",
            },
            {
                messages: 540,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T14:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T15:00:00.000Z",
            },
            {
                messages: 360,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T16:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T17:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T18:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T19:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T20:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T21:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T22:00:00.000Z",
            },
            {
                messages: 0,
                huddles: 0,
                meetings: 0,
                focus: 0,
                datetime: "2022-06-22T23:00:00.000Z",
            },
        ],
    },
];

const fragmentation = [
    {
        subject: "repos",
        value: 3,
        items: ["Static", "FE Main", "BE Testing"],
        baseline: 1.42,
    },
    {
        subject: "languages",
        value: 2,
        items: ["JavaScript", "HTML"],
        baseline: 1.39,
    },
    {
        subject: "channels",
        value: 4,
        items: ["Tech", "FE Team", "BE Team"],
        baseline: 1.74,
    },
    {
        subject: "meetings",
        value: 3,
        items: [
            "Prepare architecture for AWS",
            "Daily Standup",
            "Next Sprint/Release technical planning",
        ],
    },
    {
        subject: "peopleMeet",
        value: 3,
        items: ["e.anderson@adadot.com", "j.hughes@adadot.com", "o.parker@adadot.com"],
    },
    {
        subject: "peopleChat",
        value: 9,
        items: [
            "Emily Anderson",
            "Jacob Hughes",
            "Olivia Parker",
            "Ethan Collins",
            "Ava Peterson",
            "Isabella Hayes",
            "Mason Brooks",
        ],
    },
    {
        subject: "peopleGit",
        value: 1,
        items: ["e.anderson@adadot.com"],
    },
];

const support = [
    { name: "Jello Biafra", value: 3402 },
    { name: "Henry Rollins", value: 26203 },
    { name: "Glen Danzig", value: 176203 },
];

const upskilling = {
    expectedTotal: 378,
    newTotal: 122,
    usage: {
        expected: [
            {
                language: "TypeScript",
                lines: 297,
                files: 15,
                users: 2,
            },
            {
                language: "JavaScript",
                lines: 181,
                files: 20,
                users: 2,
            },
        ],
        new: [
            {
                language: "Markdown",
                lines: 92,
                files: 1,
                users: 1,
            },
            {
                language: "YAML",
                lines: 130,
                files: 3,
                users: 1,
            },
        ],
    },
};

const meta = {
    inactive: false,
    lastActiveAt: 1653523200,
    firstScrappedDate: 1650412800,
};

const getWellbeing = () => {
    return {
        longHours,
        fragmentation,
        outOfHours,
        focusTime,
        support,
        upskilling,
        meta,
    };
};

export default getWellbeing;
